import { useEffect, useState } from "react";
import rothko from "web/script/modules/rothko";


export const LOADING_STATES = {
    DEFAULT: 0,
    PENDING: 1,
    COMPLETE: 2,
    ERROR: 3,
};

/*  Note - parameters needs to be a reference to an object between re-renders as useEffect does not do a deep object comparison when deciding
if it should execute. For example:
```
const [rothkoOptions] = useState({ slug: productSlug, uid: productUid });
const { data, loadingState } = useRothko(endpoint, rothkoOptions);
```
This will ensure parameters is always a reference to the same object
*/
export function useRothko(endpoint, parameters) {
    const [data, updateData] = useState(undefined);
    const [loadingState, setLoadingState] = useState(LOADING_STATES.DEFAULT);
    useEffect(() => {
        async function fetchData() {
            setLoadingState(LOADING_STATES.PENDING);
            try {
                const response = await rothko.fetch(endpoint, parameters);

                updateData(response);
                setLoadingState(LOADING_STATES.COMPLETE);
            } catch (err) {
                setLoadingState(LOADING_STATES.ERROR);
            }
        }
        fetchData();
    }, [endpoint, parameters]);

    return { data, loadingState };
}
